// GERADO por scripts/gerar-dados-ts.mjs a partir de conhecimento/dados/serie-a-2026.json. Não editar à mão.
// Fonte: Wikipédia (en), seção First-team squad de cada clube (posição em 1/out/2026 ou antes); nascimento: Wikidata; campanha: tabela de 28/10/2026.
// Jogador: [nome, posição(G/Z/L/M/A), idade (0 = desconhecida), nacionalidade, nº camisa, posiçãoEstimada(1 = Z/L deduzido), lado(E/D/'')]
/** [nome, posição, idade, nacionalidade, nº camisa, posiçãoEstimada, lado, função detalhada (opcional: 'VOL' etc.)] */
export type JogadorReal = [string, 'G' | 'Z' | 'L' | 'M' | 'A', number, string, number, number, string, string?];
export interface ClubeReal { nome: string; sigla: string; cor1: string; cor2: string; tecnico: string; nivel: number; jog: JogadorReal[] }
export const SERIE_A_2026: ClubeReal[] = [
 {"nome": "Flamengo","sigla": "FLA","cor1": "#c8102e","cor2": "#111111","tecnico": "Leonardo Jardim","nivel": 19,"jog": [["Agustín Rossi","G",31,"Argentina",1,0,""
   ],["Guillermo Varela","L",33,"Uruguay",2,0,"D"
   ],["Léo Ortiz","Z",30,"BRA",3,0,""
   ],["Léo Pereira","Z",30,"Brazil",4,1,""
   ],["Erick Pulgar","M",32,"Chile",5,0,""
   ],["Ayrton Lucas","L",29,"Brazil",6,1,"E"
   ],["Luiz Araújo","A",30,"Brazil",7,0,""
   ],["Saúl Ñíguez","M",31,"Spain",8,0,""
   ],["Pedro","A",29,"Brazil",9,0,""
   ],["Giorgian de Arrascaeta","M",32,"Uruguay",10,0,""
   ],["Lucas Paquetá","M",29,"Brazil",11,0,""
   ],["Danilo","Z",35,"Brazil",13,1,""
   ],["Anthony Valencia","A",23,"Ecuador",14,0,""
   ],["Jorge Carrascal","M",28,"Colombia",15,0,""
   ],["Samuel Lino","A",26,"Brazil",16,0,""
   ],["Nicolás de la Cruz","M",29,"Uruguay",18,0,""
   ],["Gonzalo Plata","A",25,"Ecuador",19,0,""
   ],["Jorginho","M",34,"Italy",21,0,""
   ],["Emerson Royal","L",27,"Brazil",22,0,""
   ],["Alex Sandro","L",35,"Brazil",26,0,""
   ],["Bruno Henrique","A",35,"Brazil",27,0,""
   ],["Joaquín Freitas","A",19,"Argentina",30,0,""
   ],["Andrew","G",25,"Brazil",42,0,""
   ],["Vitão","Z",26,"Brazil",44,1,""
   ],["Dyogo Alves","G",22,"Brazil",49,0,""
   ],["Evertton Araújo","M",23,"Brazil",52,0,""
   ],["João Victor","Z",19,"Brazil",61,1,""
   ]
  ]
 },
 {"nome": "Fluminense","sigla": "FLU","cor1": "#7a1f3d","cor2": "#0b7a3b","tecnico": "Marcão (interino)","nivel": 15,"jog": [["Fábio","G",46,"Brazil",1,0,""
   ],["Samuel Xavier","L",36,"Brazil",2,0,"D"
   ],["Thiago Silva","Z",42,"Brazil",3,0,""
   ],["Ignácio","Z",29,"Brazil",4,1,""
   ],["Renê","L",34,"Brazil",6,0,"E"
   ],["Hulk","A",40,"Brazil",7,0,""
   ],["Matheus Martinelli","M",25,"Brazil",8,0,""
   ],["John Kennedy","A",24,"Brazil",9,0,""
   ],["Ganso","M",37,"Brazil",10,0,""
   ],["Jefferson Savarino","M",29,"Venezuela",11,0,""
   ],["Guilherme Arana","L",29,"Brazil",13,0,""
   ],["Germán Cano","A",38,"Argentina",14,0,""
   ],["Nonato","M",28,"Brazil",16,0,""
   ],["Agustín Canobbio","A",28,"Uruguay",17,0,""
   ],["Rodrigo Castillo","A",27,"Argentina",19,0,""
   ],["Igor Rabello","Z",31,"Brazil",21,1,""
   ],["Juan Pablo Freytes","L",26,"Argentina",22,1,""
   ],["Guga","Z",28,"Brazil",23,1,""
   ],["Alisson","M",33,"Brazil",25,0,""
   ],["Marcelo Pitaluga","G",23,"Brazil",27,0,""
   ],["Riquelme","A",19,"Brazil",28,0,""
   ],["Julián Millán","Z",28,"Colombia",29,1,""
   ],["Yeferson Soteldo","A",29,"Venezuela",30,0,""
   ],["Lucho Acosta","M",32,"Argentina",32,0,""
   ],["Hércules","M",26,"Brazil",35,0,""
   ],["Jemmes","Z",26,"Brazil",44,1,""
   ],["Júlio Fidelis","Z",19,"Brazil",46,1,""
   ],["Kevin Serna","A",28,"Colombia",90,0,""
   ],["Otávio","M",32,"Brazil",94,0,""
   ],["Vitor Eudes","G",28,"Brazil",98,0,""
   ]
  ]
 },
 {"nome": "Botafogo","sigla": "BOT","cor1": "#111111","cor2": "#f2f2f2","tecnico": "Tite","nivel": 12,"jog": [["Vitinho","L",27,"Brazil",2,1,"D"
   ],["Arthur Chaves","Z",25,"Brazil",3,1,""
   ],["Mateo Ponte","Z",23,"Uruguay",4,1,""
   ],["Nahuel Ferraresi","Z",27,"Venezuela",5,1,""
   ],["Cristian Medina","M",24,"Argentina",6,0,"E"
   ],["Júnior Santos","A",32,"Brazil",7,0,""
   ],["Danilo Santos","M",25,"Brazil",8,0,""
   ],["Tiquinho Soares|","A",35,"Brazil",9,0,""
   ],["Álvaro Montoro","M",19,"Argentina",10,0,""
   ],["Matheus Martins","A",23,"Brazil",11,0,""
   ],["Gabriel Batista","G",28,"Brazil",12,0,""
   ],["Alex Telles","L",33,"Brazil",13,0,""
   ],["Jordan Barrera","M",20,"Colombia",14,0,""
   ],["Warleson","G",30,"Brazil",17,0,""
   ],["Arthur Cabral","A",28,"Brazil",19,0,""
   ],["Marçal","Z",37,"Brazil",21,1,""
   ],["Hakim Ziyech","A",33,"Morocco",22,0,""
   ],["Allan","M",35,"Brazil",25,0,""
   ],["Anthony","L",21,"Brazil",26,1,""
   ],["Paulinho","Z",31,"Brazil",29,1,""
   ],["Kaio Pantaleão","Z",31,"Brazil",31,1,""
   ],["Lucas Monzón","Z",25,"Uruguay",33,1,""
   ],["Gabriel Justino","Z",20,"Brazil",34,1,""
   ],["Kadir Barría","A",19,"Panama",37,0,""
   ],["Kadu","Z",21,"Brazil",42,1,""
   ],["Kauan Toledo","A",20,"Brazil",59,0,""
   ],["Huguinho","M",19,"Brazil",75,0,""
   ],["Lucas Villalba","A",25,"Uruguay",77,0,""
   ],["Lucas Emanuel","A",17,"Brazil",79,0,""
   ],["Edenilson","M",36,"Brazil",88,0,""
   ],["Danilo Pereira","A",27,"Brazil",90,0,""
   ],["Domingos Andrade","M",23,"Angola",91,0,""
   ]
  ]
 },
 {"nome": "Vasco da Gama","sigla": "VAS","cor1": "#111111","cor2": "#f2f2f2","tecnico": "Pedro Emanuel","nivel": 13,"jog": [["Léo Jardim","G",31,"BRA",1,0,""
   ],["Puma Rodríguez","L",29,"URU",2,1,"D"
   ],["Tchê Tchê","M",34,"BRA",3,0,""
   ],["Alan Saldivia","Z",24,"URU",4,1,""
   ],["Santiago Sosa","M",27,"ARG",5,0,""
   ],["Lucas Piton","L",26,"BRA",6,1,"E"
   ],["David","A",31,"BRA",7,0,""
   ],["Jair","M",32,"BRA",8,0,""
   ],["Facundo Colidio","A",26,"ARG",9,0,""
   ],["Johan Rojas","M",24,"COL",10,0,""
   ],["Andrés Gómez","A",24,"COL",11,0,""
   ],["Daniel Fuzato","G",29,"BRA",13,0,""
   ],["Nuno Moreira","A",27,"POR",17,0,""
   ],["Marino Hinestroza","A",24,"COL",18,0,""
   ],["Bruno Duarte","A",30,"BRA",19,0,""
   ],["Brenner","A",26,"BRA",20,0,""
   ],["Alan Lescano","M",24,"ARG",22,0,""
   ],["Thiago Mendes","M",34,"BRA",23,0,""
   ],["Adson","A",26,"BRA",28,0,""
   ],["Paulinho","Z",22,"BRA",29,1,""
   ],["Robert Renan","Z",23,"BRA",30,1,""
   ],["Pablo","G",0,"BRA",37,0,""
   ],["Lucas Freitas","Z",25,"BRA",43,1,""
   ],["Carlos Cuesta","Z",27,"COL",46,1,""
   ],["Gabriel Pereira","Z",26,"BRA",55,1,""
   ],["João Vitor","Z",21,"BRA",60,1,""
   ],["Walace Falcão","Z",0,"BRA",64,1,""
   ],["Cuiabano","Z",23,"BRA",66,1,""
   ],["Claudio Spinelli","A",29,"ARG",77,0,""
   ],["Ramon Rique","M",19,"BRA",83,0,""
   ],["Mateus Carvalho","M",24,"BRA",85,0,""
   ],["Cauan Barros","M",22,"BRA",88,0,""
   ],["Paulo Henrique","Z",30,"BRA",96,1,""
   ]
  ]
 },
 {"nome": "Palmeiras","sigla": "PAL","cor1": "#006437","cor2": "#f2f2f2","tecnico": "Abel Ferreira","nivel": 18,"jog": [["Carlos Miguel","G",28,"Brazil",1,0,""
   ],["Alexander Barboza","L",31,"Argentina",2,1,"D"
   ],["Bruno Fuchs","Z",27,"Brazil",3,0,""
   ],["Agustín Giay","Z",22,"Argentina",4,1,""
   ],["Jefté","L",22,"Brazil",6,1,"E"
   ],["Felipe Anderson","M",33,"Brazil",7,0,""
   ],["Andreas Pereira","M",30,"Brazil",8,0,""
   ],["Vitor Roque","A",21,"Brazil",9,0,""
   ],["Paulinho","A",26,"Brazil",10,0,""
   ],["Jhon Arias","A",29,"Colombia",11,0,""
   ],["Khellven","L",25,"Brazil",12,0,""
   ],["Marcelo Lomba","G",39,"Brazil",14,0,""
   ],["Gustavo Gómez","Z",33,"Paraguay",15,0,""
   ],["Marlon Freitas","M",31,"Brazil",17,0,""
   ],["Maurício","M",25,"Paraguay",18,0,""
   ],["Ramón Sosa","A",27,"Paraguay",19,0,""
   ],["Bruno Bertinato","G",28,"Brazil",21,0,""
   ],["Joaquín Piquerez","L",28,"Uruguay",22,1,""
   ],["Murilo","L",29,"Brazil",26,1,""
   ],["Lucas Evangelista","M",31,"Brazil",30,0,""
   ],["Emiliano Martínez","M",27,"Uruguay",32,0,""
   ],["José Manuel López","A",25,"Argentina",42,0,""
   ],["Luiz Benedetti","Z",20,"Brazil",43,1,""
   ],["Larson","M",21,"Brazil",48,0,""
   ],["Arthur Gabriel","Z",21,"Brazil",56,1,""
   ]
  ]
 },
 {"nome": "Corinthians","sigla": "COR","cor1": "#111111","cor2": "#f2f2f2","tecnico": "Clarence Seedorf","nivel": 11,"jog": [["Hugo Souza","G",27,"BRA",1,0,""
   ],["Matheuzinho","L",26,"BRA",2,1,"D"
   ],["Gabriel Paulista","Z",35,"BRA",3,0,""
   ],["João Pedro","Z",22,"BRA",4,1,""
   ],["André Ramalho","Z",34,"BRA",5,1,""
   ],["Breno Bidon","M",21,"BRA",7,0,""
   ],["Rodrigo Garro","M",28,"ARG",8,0,""
   ],["Yuri Alberto","A",25,"BRA",9,0,""
   ],["Memphis Depay","A",32,"NED",10,0,""
   ],["Vitinho","M",33,"BRA",11,0,""
   ],["Gustavo Henrique","Z",33,"BRA",13,0,""
   ],["Raniele","M",29,"BRA",14,0,""
   ],["Pedro Raul","A",29,"BRA",18,0,""
   ],["André Carrillo","M",35,"PER",19,0,""
   ],["Pedro Milans","Z",24,"URU",20,1,""
   ],["Matheus Bidu","Z",27,"BRA",21,1,""
   ],["Matheus Pereira","M",28,"BRA",23,0,""
   ],["Fabrizio Angileri","L",32,"ARG",26,1,""
   ],["Allan","M",29,"BRA",29,0,""
   ],["Kayke","A",22,"BRA",31,0,""
   ],["Charles","M",30,"BRA",35,0,""
   ],["Kaio César","A",22,"BRA",37,0,""
   ],["Felipe Longo","G",21,"BRA",40,0,""
   ],["Hugo Farias","Z",29,"BRA",46,1,""
   ],["André","M",20,"BRA",49,0,""
   ],["Kauê","G",22,"BRA",51,0,""
   ],["Zakaria Labyad","M",33,"MAR",52,0,""
   ],["Luiz Gustavo","M",20,"BRA",54,0,""
   ],["Iago Machado","Z",17,"BRA",55,1,""
   ],["Gui Negão","A",19,"BRA",56,0,""
   ],["Dieguinho","A",19,"BRA",61,0,""
   ],["Jesse Lingard","M",33,"ENG",77,0,""
   ],["Alex Santana","M",31,"BRA",80,0,""
   ]
  ]
 },
 {"nome": "São Paulo","sigla": "SAO","cor1": "#e4002b","cor2": "#111111","tecnico": "Dorival Júnior","nivel": 13,"jog": [["Rafael Tolói","Z",36,"ITA",2,0,"D"
   ],["Robert Arboleda","Z",35,"ECU",5,1,""
   ],["Lucas Moura","M",34,"BRA",7,0,""
   ],["Marcos Antônio","M",26,"BRA",8,0,""
   ],["Jonathan Calleri","A",33,"ARG",9,0,""
   ],["Luciano","A",33,"BRA",10,0,""
   ],["Ferreira","A",28,"BRA",11,0,""
   ],["Iago Borduchi","Z",29,"BRA",12,1,""
   ],["Enzo Díaz","Z",30,"ARG",13,1,""
   ],["Damián Bobadilla","M",25,"PAR",16,0,""
   ],["André Silva","A",29,"BRA",17,0,""
   ],["Wendell","L",33,"BRA",18,0,""
   ],["Lucas Ramon","Z",32,"BRA",19,1,""
   ],["Aurélio Buta","Z",29,"POR",20,1,""
   ],["Cédric Soares","L",35,"POR",21,0,""
   ],["Domingos Duarte","L",31,"POR",22,1,""
   ],["Rafael","G",37,"BRA",23,0,""
   ],["Victor Sá","A",32,"BRA",27,0,""
   ],["Newton","M",26,"BRA",28,0,""
   ],["Pablo Maia","M",24,"BRA",29,0,""
   ],["Carlos Coronel","G",29,"PAR",31,0,""
   ],["Pedro Lima","Z",20,"BRA",32,1,""
   ],["Tetê","A",0,"BRA",34,0,""
   ],["Sabino","Z",30,"BRA",35,1,""
   ],["Artur","A",28,"BRA",37,0,""
   ],["João Pedro","G",0,"BRA",41,0,""
   ],["Gustavo Santana","A",21,"BRA",43,0,""
   ],["Lucca Marques","A",19,"BRA",45,0,""
   ],["Pedro Ferreira","M",19,"BRA",46,0,""
   ],["Djhordney","M",19,"BRA",48,0,""
   ],["Ryan Francisco","A",19,"BRA",49,0,""
   ],["Young","G",24,"BRA",50,0,""
   ],["Felipe Preis","G",0,"BRA",52,0,""
   ],["Isac","Z",20,"BRA",53,1,""
   ],["Luis Osorio","Z",20,"BRA",54,1,""
   ],["Nicolas","Z",19,"BRA",56,1,""
   ],["Cauly","M",31,"BRA",80,0,""
   ],["Danielzinho","M",31,"BRA",94,0,""
   ]
  ]
 },
 {"nome": "Santos","sigla": "SAN","cor1": "#f2f2f2","cor2": "#111111","tecnico": "Cuca","nivel": 14,"jog": [["Diógenes","G",25,"Brazil",1,0,""
   ],["Vinicius Lira","Z",19,"Brazil",3,1,""
   ],["Lucas Veríssimo","Z",31,"Brazil",4,1,""
   ],["João Schmidt","M",33,"Brazil",5,0,""
   ],["Arthur","M",30,"Brazil",6,0,"E"
   ],["Everton Cebolinha","A",30,"Brazil",7,0,""
   ],["Gabriel Bontempo","M",21,"Brazil",8,0,""
   ],["Gabriel Barbosa","A",30,"Brazil",9,0,""
   ],["Neymar","M",34,"Brazil",10,0,""
   ],["Philippe Coutinho","M",34,"Brazil",11,0,""
   ],["Luan Peres","Z",32,"Brazil",14,1,""
   ],["Willian Arão","M",33,"Brazil",15,0,""
   ],["Thaciano","A",31,"Brazil",16,0,""
   ],["Gustavo Caballero","A",25,"Paraguay",17,0,""
   ],["Igor Vinícius","Z",29,"Brazil",18,1,""
   ],["Pepê Fermino","M",0,"Brazil",20,0,""
   ],["Moisés","A",30,"Brazil",21,0,""
   ],["Álvaro Barreal","A",26,"Argentina",22,0,""
   ],["Rodinei","L",34,"Brazil",23,0,""
   ],["Gabriel Menino","Z",26,"Brazil",25,1,""
   ],["João Ananias","L",19,"Brazil",26,1,""
   ],["Davizinho","Z",18,"Brazil",27,1,""
   ],["Christian Oliva","M",30,"Uruguay",28,0,""
   ],["Miguel Terceros","M",22,"Bolivia",30,0,""
   ],["Gonzalo Escobar","Z",29,"Argentina",31,1,""
   ],["Benjamín Rollheiser","M",26,"Argentina",32,0,""
   ],["Rony","A",31,"Brazil",33,0,""
   ],["João Paulo","G",31,"Brazil",34,0,""
   ],["Rafael Gonzaga","Z",18,"Brazil",38,1,""
   ],["João Alencar","Z",0,"Brazil",42,1,""
   ],["Lima","M",30,"Brazil",45,0,""
   ],["Gustavo Henrique","M",21,"Brazil",48,0,""
   ],["Nadson","A",17,"Brazil",57,0,""
   ],["Rodrigo Falcão","G",21,"Brazil",67,0,""
   ],["Gabriel Brazão","G",26,"Brazil",77,0,""
   ],["João Pedro","G",18,"Brazil",79,0,""
   ],["Samuel Pierri","M",18,"Brazil",81,0,""
   ]
  ]
 },
 {"nome": "Mirassol","sigla": "MIR","cor1": "#f5c400","cor2": "#0b7a3b","tecnico": "Rafael Guanaes","nivel": 12,"jog": [["Georgemy","G",31,"BRA",1,0,""
   ],["Lucas Oliveira","L",30,"BRA",2,1,"D"
   ],["Willian Machado","Z",29,"BRA",3,1,""
   ],["Japa","M",22,"BRA",5,0,""
   ],["Reinaldo","L",37,"BRA",6,0,"E"
   ],["Shaylon","M",29,"BRA",7,0,""
   ],["Denilson","M",25,"BRA",8,0,""
   ],["Zé Roberto","A",33,"BRA",9,0,""
   ],["Chico Kim","M",35,"BRA",10,0,""
   ],["Negueba","A",26,"BRA",11,0,""
   ],["Victor Luis","L",33,"BRA",12,0,""
   ],["Gustavo Silva","A",29,"BRA",16,0,""
   ],["Fernandinho","A",29,"BRA",17,0,""
   ],["Elias","Z",27,"BRA",18,1,""
   ],["Daniel Borges","Z",33,"BRA",20,1,""
   ],["José Aldo","M",28,"BRA",21,0,""
   ],["Walter","G",38,"BRA",22,0,""
   ],["Alex Muralha","G",36,"BRA",23,0,""
   ],["Neto Moura","M",30,"BRA",25,0,""
   ],["Bruno Santos","A",29,"BRA",30,0,""
   ],["Igor Formiga","Z",27,"BRA",32,1,""
   ],["Eduardo","M",37,"BRA",33,0,""
   ],["João Victor","Z",29,"BRA",34,1,""
   ],["Gabriel Knesowitsch","Z",23,"BRA",44,1,""
   ],["Marcelinho","Z",0,"BRA",53,1,""
   ],["Gustavo Cazonatti","M",30,"BRA",55,0,""
   ],["Alesson","A",27,"BRA",77,0,""
   ],["Wallisson","M",29,"BRA",80,0,""
   ],["Thomazella","G",36,"BRA",90,0,""
   ],["Edson Carioca","A",29,"BRA",95,0,""
   ],["Carlos Eduardo","A",30,"BRA",96,0,""
   ],["André Luis","A",32,"BRA",99,0,""
   ]
  ]
 },
 {"nome": "Red Bull Bragantino","sigla": "RBB","cor1": "#f2f2f2","cor2": "#c8102e","tecnico": "Vagner Mancini","nivel": 13,"jog": [["Cleiton","G",29,"BRA",1,0,""
   ],["Guzmán Rodríguez","L",26,"URU",2,1,"D"
   ],["Eduardo Santos","Z",28,"BRA",3,1,""
   ],["Alix Vinicius","Z",26,"BRA",4,1,""
   ],["Fabinho","M",24,"BRA",5,0,""
   ],["Gabriel","M",34,"BRA",6,0,"E"
   ],["Eric Ramires","M",26,"BRA",7,0,""
   ],["Eduardo Sasha","A",34,"BRA",8,0,""
   ],["Isidro Pitta","A",27,"PAR",9,0,""
   ],["Fernando","A",27,"BRA",11,0,""
   ],["Vanderlan","Z",24,"BRA",12,1,""
   ],["Nacho Sosa","M",23,"URU",15,0,""
   ],["Gustavo Marques","L",25,"BRA",16,1,""
   ],["Vinicinho","A",22,"BRA",17,0,""
   ],["Tiago Volpi","G",35,"BRA",18,0,""
   ],["Bruno Gonçalves","A",23,"BRA",19,0,""
   ],["Rodriguinho","M",22,"BRA",20,0,""
   ],["Lucas Barbosa","A",25,"BRA",21,0,""
   ],["Gustavo Neves","M",22,"BRA",22,0,""
   ],["Agustín Sant'Anna","Z",29,"URU",23,1,""
   ],["Davi Gomes","A",21,"BRA",27,0,""
   ],["Patrick","M",22,"BRA",28,0,""
   ],["Juninho Capixaba","Z",29,"BRA",29,1,""
   ],["Henry Mosquera","A",24,"COL",30,0,""
   ],["José María Herrera","A",23,"ARG",32,0,""
   ],["Andrés Hurtado","Z",24,"ECU",34,1,""
   ],["Matheus Fernandes","M",28,"BRA",35,0,""
   ],["Fabrício","G",26,"BRA",37,0,""
   ],["Wallace Yan","A",21,"BRA",47,0,""
   ],["Cauê Nascimento","Z",19,"BRA",51,1,""
   ],["Gustavo Reis","G",0,"BRA",56,0,""
   ],["Marcelinho Braz","A",22,"BRA",57,0,""
   ]
  ]
 },
 {"nome": "Cruzeiro","sigla": "CRU","cor1": "#0a4aa6","cor2": "#f2f2f2","tecnico": "Artur Jorge","nivel": 16,"jog": [["Cássio","G",39,"Brazil",1,0,""
   ],["Kauã Moraes","L",20,"Brazil",2,1,"D"
   ],["Zé Lucas","M",18,"Brazil",5,0,""
   ],["Matías Viña","L",28,"Uruguay",6,1,"E"
   ],["Matheus Henrique","M",28,"Brazil",7,0,""
   ],["Gerson","M",29,"Brazil",8,0,""
   ],["Bruno Rodrigues","A",29,"Brazil",9,0,""
   ],["Matheus Pereira","M",30,"Brazil",10,0,""
   ],["Marquinhos","A",23,"Brazil",11,0,""
   ],["William","L",31,"Brazil",12,0,""
   ],["Fabrício Bruno","Z",30,"Brazil",15,1,""
   ],["Lucas Silva","M",33,"Brazil",16,0,""
   ],["Luis Sinisterra","A",27,"Colombia",17,0,""
   ],["Kaio Jorge","A",24,"Brazil",19,0,""
   ],["Wesley","A",21,"Brazil",20,0,""
   ],["Néiser Villarreal","A",21,"Colombia",22,0,""
   ],["Fagner","Z",37,"Brazil",23,1,""
   ],["Marcelo Eráclito","G",0,"Brazil",24,0,""
   ],["Lucas Villalba","Z",32,"Argentina",25,1,""
   ],["Gabriel Rojas","Z",29,"Argentina",27,1,""
   ],["Lucas Romero","M",32,"Argentina",29,0,""
   ],["Jonathan Jesus","Z",22,"Brazil",34,1,""
   ],["Rhuan Gabriel","M",0,"Brazil",40,0,""
   ],["Léo Aragão","G",24,"Brazil",41,0,""
   ],["João Marcelo","Z",26,"Brazil",43,1,""
   ],["Vitor Lamounier","G",0,"Brazil",51,0,""
   ],["Rayan Lelis","A",19,"Brazil",57,0,""
   ],["João Costa","A",21,"Portugal",67,0,""
   ],["Kaique Kenji","A",20,"Brazil",70,0,""
   ],["Gabriel Pec","A",25,"Brazil",77,0,""
   ],["Otávio","G",20,"Brazil",81,0,""
   ],["Wanderson","A",32,"Belgium",94,0,""
   ],["Luciano Rodríguez","A",23,"Uruguay",97,0,""
   ],["Keny Arroyo","A",20,"Ecuador",99,0,""
   ]
  ]
 },
 {"nome": "Atlético-MG","sigla": "CAM","cor1": "#111111","cor2": "#f2f2f2","tecnico": "Eduardo Domínguez","nivel": 15,"jog": [["Gabriel Delfim","G",24,"Brazil",1,0,""
   ],["Natanael","L",24,"Brazil",2,1,"D"
   ],["Léo Duarte","Z",30,"Brazil",3,1,""
   ],["Ruan Tressoldi","Z",27,"Brazil",4,1,""
   ],["Alexsander","M",23,"Brazil",5,0,""
   ],["Renan Lodi","L",28,"Brazil",6,1,"E"
   ],["Fred","M",33,"Brazil",7,0,""
   ],["Maycon","M",29,"Brazil",8,0,""
   ],["Mateo Cassierra","A",29,"Colombia",9,0,""
   ],["Gustavo Scarpa","M",32,"Brazil",10,0,""
   ],["Bernard","M",34,"Brazil",11,0,""
   ],["Lyanco","Z",29,"Brazil",13,1,""
   ],["Vitor Hugo","Z",35,"Brazil",14,1,""
   ],["Kevin Castaño","M",26,"Colombia",15,0,""
   ],["Igor Gomes","M",27,"Brazil",17,0,""
   ],["Thiago Borbas","A",24,"Uruguay",18,0,""
   ],["Reinier","M",24,"Brazil",19,0,""
   ],["Alan Franco","M",28,"Ecuador",21,0,""
   ],["Everson","G",36,"Brazil",22,0,""
   ],["Ángelo Preciado","Z",28,"Ecuador",23,1,""
   ],["Tomás Pérez","M",21,"Argentina",25,0,""
   ],["Alan Minda","A",23,"Ecuador",27,0,""
   ],["Tomás Cuello","A",26,"Argentina",28,0,""
   ],["Cauã Soares","A",0,"Brazil",29,0,""
   ],["Victor Hugo","M",22,"Brazil",30,0,""
   ],["Robert","G",0,"Brazil",31,0,""
   ],["Kauã Pascini","Z",18,"Brazil",36,1,""
   ],["Índio","M",0,"Brazil",38,0,""
   ],["Mamady Cissé","M",19,"Guinea",39,0,""
   ],["Vitão","Z",18,"Brazil",40,1,""
   ],["Pedro Cobra","G",0,"Brazil",46,0,""
   ],["Dudu","A",34,"Brazil",92,0,""
   ]
  ]
 },
 {"nome": "Grêmio","sigla": "GRE","cor1": "#0d80bf","cor2": "#111111","tecnico": "Renato Gaúcho","nivel": 12,"jog": [["Weverton","G",38,"BRA",1,0,""
   ],["Fabián Balbuena","Z",35,"PAR",2,0,"D"
   ],["Wagner Leonardo","Z",27,"BRA",3,1,""
   ],["Walter Kannemann","Z",35,"ARG",4,0,""
   ],["Juan Nardoni","M",24,"ARG",5,0,""
   ],["Gustavo Martins","L",24,"BRA",6,1,"E"
   ],["Cristian Pavon","A",30,"ARG",7,0,""
   ],["Erick Noriega","M",25,"PER",8,0,""
   ],["Francis Amuzu","A",27,"GHA",9,0,""
   ],["Filip Krovinović","M",31,"CRO",10,0,""
   ],["Tetê","A",26,"BRA",11,0,""
   ],["Gabriel Grando","G",26,"BRA",12,0,""
   ],["Marcos Rocha","Z",37,"BRA",14,1,""
   ],["Danilo Barbosa","M",30,"BRA",15,0,""
   ],["Dodi","M",30,"BRA",17,0,""
   ],["João Pedro","Z",29,"BRA",18,1,""
   ],["Mathías Villasanti","M",29,"PAR",20,0,""
   ],["Martin Braithwaite","A",35,"DEN",22,0,""
   ],["Marlon","Z",29,"BRA",23,1,""
   ],["Thiago Beltrame","G",23,"BRA",24,0,""
   ],["Diego Caito","Z",0,"BRA",27,1,""
   ],["Matheus Nascimento","A",22,"BRA",30,0,""
   ],["Gabriel Menegon","G",18,"BRA",31,0,""
   ],["Caio Paulista","Z",28,"BRA",38,1,""
   ],["Tiago","M",18,"BRA",39,0,""
   ],["Athos","Z",0,"BRA",42,1,""
   ],["Luis Eduardo","Z",18,"BRA",43,1,""
   ],["Roger","M",18,"BRA",47,0,""
   ],["Pedro Gabriel","Z",19,"BRA",54,1,""
   ],["Riquelme","M",20,"BRA",65,0,""
   ],["Jovane Cabral","A",28,"CPV",77,0,""
   ],["Wallace","Z",21,"BRA",82,1,""
   ],["Carlos Vinícius","A",31,"BRA",95,0,""
   ],["José Enamorado","A",27,"COL",99,0,""
   ]
  ]
 },
 {"nome": "Internacional","sigla": "INT","cor1": "#c8102e","cor2": "#f2f2f2","tecnico": "Eduardo Baptista","nivel": 12,"jog": [["Sergio Rochet","G",33,"URU",1,0,""
   ],["Guillermo Maripán","Z",32,"CHI",3,1,""
   ],["Félix Torres","Z",29,"ECU",4,1,""
   ],["Rodrigo Villagra","M",25,"ARG",5,0,""
   ],["Matheus Bahia","L",27,"BRA",6,1,"E"
   ],["Johan Carbonero","A",27,"COL",7,0,""
   ],["Bruno Henrique","M",37,"BRA",8,0,""
   ],["Alerrandro","A",26,"BRA",9,0,""
   ],["Alan Patrick","M",35,"BRA",10,0,""
   ],["Kayky","A",23,"BRA",11,0,""
   ],["Anthoni","G",24,"BRA",12,0,""
   ],["Bruno Gomes","Z",25,"BRA",15,1,""
   ],["Ronaldo","M",30,"BRA",16,0,""
   ],["Niclas Eliasson","A",30,"SWE",17,0,""
   ],["Juninho","Z",31,"BRA",18,1,""
   ],["Kauan Jesus","G",23,"BRA",22,0,""
   ],["Matheus Cunha","G",25,"BRA",23,0,""
   ],["Gabriel Mercado","Z",39,"ARG",25,0,""
   ],["Alexandro Bernabei","L",26,"ARG",26,0,""
   ],["Paulinho","M",29,"BRA",27,0,""
   ],["Vitinho","A",27,"BRA",28,0,""
   ],["Thiago Maia","M",29,"BRA",29,0,""
   ],["Calebe","M",26,"BRA",30,0,""
   ],["Diego Esser","G",0,"BRA",32,0,""
   ],["Braian Aguirre","Z",26,"ARG",35,1,""
   ],["Victor Gabriel","Z",22,"BRA",41,1,""
   ]
  ]
 },
 {"nome": "Coritiba","sigla": "CTB","cor1": "#0b7a3b","cor2": "#f2f2f2","tecnico": "Guilherme Bossle (interino)","nivel": 13,"jog": [["Pedro Morisco","G",22,"BRA",1,0,""
   ],["Tinga","L",33,"BRA",2,1,"D"
   ],["Maicon","Z",38,"BRA",3,0,""
   ],["Rodrigo Moledo","Z",39,"BRA",4,0,""
   ],["Nicolás Fonseca","M",28,"URU",5,0,""
   ],["Felipe Jonatan","L",28,"BRA",6,1,"E"
   ],["Joaquín Lavega","A",21,"URU",7,0,""
   ],["Josué Pesqueira","M",36,"POR",10,0,""
   ],["Lucas Ronier","A",21,"BRA",11,0,""
   ],["Keiller","G",29,"BRA",13,0,""
   ],["Fabricio Bustos","L",30,"ARG",14,0,""
   ],["Alejandro Ararat","M",0,"COL",15,0,""
   ],["Brian Ocampo","A",27,"URU",17,0,""
   ],["Paulo Roberto","A",0,"BRA",18,0,""
   ],["Sebastián Gómez","M",30,"COL",19,0,""
   ],["Keno","A",35,"BRA",20,0,""
   ],["Thiago Santos","Z",37,"BRA",21,1,""
   ],["Pedro Rangel","G",26,"BRA",22,0,""
   ],["Tiago Cóser","Z",22,"BRA",23,1,""
   ],["Richard","M",32,"BRA",25,0,""
   ],["Bruno Melo","L",34,"BRA",26,1,""
   ],["Fabinho","A",27,"BRA",28,0,""
   ],["Pedro Rocha","A",32,"BRA",32,0,""
   ],["Vini Paulista","M",25,"BRA",36,0,""
   ],["Gustavo Silva","M",24,"BRA",39,0,""
   ],["Vitor Tissi","M",0,"BRA",50,0,""
   ],["Jacy Maranhão","Z",29,"BRA",55,1,""
   ],["Rodrigo Gelado","Z",23,"BRA",66,1,""
   ],["Benassi","G",0,"BRA",67,0,""
   ],["Breno Lopes","A",30,"BRA",77,0,""
   ],["Renato Marques","A",22,"BRA",78,0,""
   ],["Lucas Taverna","Z",19,"BRA",86,1,""
   ],["Rodrigo Rodrigues","A",30,"BRA",99,0,""
   ]
  ]
 },
 {"nome": "Athletico-PR","sigla": "CAP","cor1": "#c8102e","cor2": "#111111","tecnico": "Odair Hellmann","nivel": 16,"jog": [["Mycael","G",22,"Brazil",1,0,""
   ],["Gilberto dos Santos","L",21,"Brazil",2,1,"D"
   ],["Léo Pelé","Z",30,"Brazil",3,1,""
   ],["Arthur Dias","Z",19,"Brazil",4,1,""
   ],["Felipinho","M",25,"Brazil",5,0,""
   ],["Léo Derik","L",21,"Brazil",6,1,"E"
   ],["Stiven Mendoza","A",34,"Colombia",7,0,""
   ],["João Cruz","M",20,"Brazil",8,0,""
   ],["Kevin Viveros","A",26,"Colombia",9,0,""
   ],["Bruno Zapelli","M",24,"Argentina",10,0,""
   ],["Gilberto Moraes","L",33,"Brazil",12,0,""
   ],["Luiz Gustavo","M",39,"Brazil",14,0,""
   ],["Jadson","M",33,"Brazil",16,0,""
   ],["Alejandro García","M",25,"Colombia",17,0,""
   ],["Kerwin Vargas","A",24,"Colombia",18,0,""
   ],["Jorge Rivaldo","A",23,"Colombia",19,0,""
   ],["Leozinho","A",28,"Brazil",21,0,""
   ],["Carlos Terán","L",26,"Colombia",22,1,""
   ],["Santos","G",36,"Brazil",23,0,""
   ],["Dantas","Z",22,"Brazil",25,1,""
   ],["Claudinho","L",21,"Brazil",26,1,""
   ],["Juan Portilla","M",28,"Colombia",27,0,""
   ],["Gastón Benavídez","Z",31,"Argentina",29,1,""
   ],["Juan Felipe Aguirre","Z",30,"Colombia",33,1,""
   ],["Lucas Esquivel","Z",25,"Argentina",37,1,""
   ],["Matheus Soares","G",0,"Brazil",42,0,""
   ],["Felipe Chiqueti","A",21,"Brazil",47,0,""
   ],["Renan Viana","A",0,"Brazil",50,0,""
   ],["Dudu Kogitzki","M",20,"Brazil",53,0,""
   ],["Riquelme","M",21,"Brazil",63,0,""
   ],["Renan Peixoto","A",26,"Brazil",70,0,""
   ]
  ]
 },
 {"nome": "Chapecoense","sigla": "CHA","cor1": "#0b7a3b","cor2": "#f2f2f2","tecnico": "Rafael Lacerda","nivel": 9,"jog": [["Rafael Santos","G",37,"BRA",1,0,""
   ],["Eduardo Doma","Z",28,"BRA",3,1,""
   ],["João Paulo","Z",29,"BRA",4,1,""
   ],["Heitor","Z",25,"BRA",5,1,""
   ],["Mancha","L",25,"BRA",6,1,"E"
   ],["Marcinho","A",31,"BRA",7,0,""
   ],["Robert Santos","M",23,"BRA",8,0,""
   ],["Túlio Eduardo","A",0,"BRA",9,0,""
   ],["Giovanni Augusto","M",37,"BRA",10,0,""
   ],["Yannick Bolasie","A",37,"COD",11,0,""
   ],["Fernando","Z",27,"BRA",12,1,""
   ],["Gabriel Werner","G",0,"BRA",14,0,""
   ],["Rafael Thyere","Z",33,"BRA",15,1,""
   ],["Bruno Matias","M",27,"BRA",16,0,""
   ],["Vinicius Balieiro","M",27,"BRA",17,0,""
   ],["David Antunes","M",21,"BRA",19,0,""
   ],["Bruno Tubarão","Z",31,"BRA",20,1,""
   ],["Kauan Faria","Z",0,"BRA",21,1,""
   ],["Max Alves","M",25,"BRA",22,0,""
   ],["Dudu","L",29,"BRA",23,0,""
   ],["Victor Caetano","Z",0,"BRA",25,1,""
   ],["Everton","L",31,"BRA",26,1,""
   ],["Camilo","M",27,"BRA",27,0,""
   ],["Franco Rossi","A",24,"URU",29,0,""
   ],["Matheus Aurélio","G",27,"BRA",30,0,""
   ],["Maurício Garcez","A",29,"BRA",31,0,""
   ],["Kainã","G",0,"BRA",34,0,""
   ],["Vinicius Eduardo","Z",0,"BRA",35,1,""
   ],["Rosivan","M",0,"BRA",55,0,""
   ],["Rubens Ricoldi","A",0,"BRA",70,0,""
   ],["Dylan Borrero","A",24,"COL",77,0,""
   ],["Miguel Carvalho","M",21,"ESP",80,0,""
   ],["Yago Felipe","M",31,"BRA",88,0,""
   ],["Bruno Pacheco","Z",34,"BRA",91,1,""
   ],["Kevin Ramírez","A",25,"URU",94,0,""
   ],["Anderson","G",28,"BRA",98,0,""
   ],["Rafael Carvalheira","M",27,"BRA",99,0,""
   ]
  ]
 },
 {"nome": "Bahia","sigla": "BAH","cor1": "#0a4aa6","cor2": "#c8102e","tecnico": "Rogério Ceni","nivel": 15,"jog": [["Ronaldo","G",30,"BRA",1,0,""
   ],["Marco Moreno","Z",25,"ESP",3,0,""
   ],["Kanu","Z",29,"BRA",4,1,""
   ],["Nicolás Acevedo","M",27,"URU",5,0,""
   ],["Jean Lucas","M",28,"BRA",6,0,"E"
   ],["Ademir","A",31,"BRA",7,0,""
   ],["Caio Alexandre","M",27,"BRA",8,0,""
   ],["Alejo Véliz","A",23,"ARG",9,0,""
   ],["Éverton Ribeiro","M",37,"BRA",10,0,""
   ],["Rodrigo Nestor","M",26,"BRA",11,0,""
   ],["Willian José","A",34,"BRA",12,0,""
   ],["Erick","M",28,"BRA",14,0,""
   ],["Michel Araújo","M",30,"URU",15,0,""
   ],["Erick Pulga","A",26,"BRA",16,0,""
   ],["Guido Herrera","G",34,"ARG",17,0,""
   ],["Lautaro López","M",21,"ARG",18,0,""
   ],["Léo Vieira","G",36,"BRA",22,0,""
   ],["Mateo Sanabria","A",22,"ARG",23,0,""
   ],["Everaldo","A",35,"BRA",27,0,""
   ],["Román Gómez","Z",22,"ARG",31,1,""
   ],["David Duarte","Z",31,"BRA",33,1,""
   ],["Luiz Gustavo","Z",20,"BRA",43,1,""
   ],["Marcos Victor","Z",24,"BRA",44,1,""
   ],["Luciano Juba","Z",27,"BRA",46,1,""
   ],["Kauê Furquim","A",17,"BRA",57,0,""
   ],["David Martins","M",19,"BRA",63,0,""
   ],["Zé Guilherme","Z",21,"BRA",66,1,""
   ],["Ruan Pablo","A",18,"BRA",77,0,""
   ],["Kike Olivera","A",24,"URU",99,0,""
   ]
  ]
 },
 {"nome": "Vitória","sigla": "VIT","cor1": "#c8102e","cor2": "#111111","tecnico": "Jair Ventura","nivel": 12,"jog": [["Lucas Arcanjo","G",28,"BRA",1,0,""
   ],["Emanuel Brítez","L",34,"ARG",2,1,"D"
   ],["Darlan","Z",23,"BRA",3,1,""
   ],["Camutanga","Z",33,"BRA",4,1,""
   ],["Emmanuel Martínez","M",32,"ARG",6,0,"E"
   ],["Marinho","A",36,"BRA",7,0,""
   ],["Tomás Pochettino","M",30,"ARG",8,0,""
   ],["Alex Bruno","A",27,"BRA",9,0,""
   ],["Matheuzinho","M",29,"BRA",10,0,""
   ],["Osvaldo","A",39,"BRA",11,0,""
   ],["Diego Tarzia","A",23,"ARG",12,0,""
   ],["Ramon","Z",25,"BRA",13,1,""
   ],["Walace","M",31,"BRA",15,0,""
   ],["Rúben Ismael","M",27,"POR",16,0,""
   ],["Kauan Coutinho","Z",0,"BRA",18,1,""
   ],["Lucas Silva","A",27,"BRA",20,0,""
   ],["Dudu","M",27,"BRA",21,0,""
   ],["Fabrí","A",26,"BRA",23,0,""
   ],["Cacá","Z",27,"BRA",25,1,""
   ],["Edenilson","L",21,"BRA",26,1,""
   ],["Anderson Pato","A",0,"BRA",28,0,""
   ],["Erick","A",28,"BRA",33,0,""
   ],["Fintelman","G",0,"BRA",35,0,""
   ],["Luan Cândido","L",25,"BRA",36,0,""
   ],["Wendell Santos","M",21,"BRA",41,0,""
   ],["Edu Ribeiro","Z",26,"BRA",43,1,""
   ],["Gabriel Baralhas","M",28,"BRA",44,0,""
   ],["Nathan Mendes","Z",24,"BRA",45,1,""
   ],["Fabiano","Z",26,"BRA",70,1,""
   ],["Yuri Sena","G",25,"BRA",71,0,""
   ],["Ignacio Laquintana","A",27,"URU",77,0,""
   ],["Renato Kayzer","A",30,"BRA",79,0,""
   ],["Jamerson","Z",28,"BRA",83,1,""
   ],["Zé Vitor","M",26,"BRA",88,0,""
   ],["Renê","A",23,"BRA",91,0,""
   ],["Caíque Gonçalves","M",31,"BRA",95,0,""
   ],["Mateus Silva","Z",28,"BRA",98,1,""
   ]
  ]
 },
 {"nome": "Remo","sigla": "REM","cor1": "#0a2a66","cor2": "#f2f2f2","tecnico": "Thiago Carpini","nivel": 10,"jog": [["Alexandre","G",0,"BRA",1,0,""
   ],["Matheus Alexandre","L",27,"BRA",2,0,"D"
   ],["Matheus Felipe","Z",27,"BRA",4,1,""
   ],["Léo Andrade","Z",28,"BRA",5,1,""
   ],["Marlon","L",32,"BRA",6,1,"E"
   ],["Jajá","A",28,"BRA",7,0,""
   ],["Patrick","M",34,"BRA",8,0,""
   ],["Gabriel Poveda","A",28,"BRA",9,0,""
   ],["Jáderson","M",26,"BRA",10,0,""
   ],["Marllon","Z",34,"BRA",13,1,""
   ],["Leonel Picco","M",28,"ARG",14,0,""
   ],["Vitor Bueno","M",32,"BRA",15,0,""
   ],["Cristian Tassano","Z",30,"URU",17,1,""
   ],["Duplexe Tchamba","Z",28,"CMR",18,1,""
   ],["Gabriel Taliari","A",29,"BRA",19,0,""
   ],["Antonio Galeano","A",26,"PAR",21,0,""
   ],["Yago Pikachu","A",34,"BRA",22,0,""
   ],["Franco Catarozzi","M",26,"URU",23,0,""
   ],["David Braga","M",24,"BRA",26,0,""
   ],["Zé Ivaldo","Z",29,"BRA",27,1,""
   ],["Zé Welison","M",31,"BRA",28,0,""
   ],["João Victor","G",0,"BRA",30,0,""
   ],["Edson Fernando","M",28,"BRA",35,0,""
   ],["Eduardo Melo","A",25,"BRA",39,0,""
   ],["Zé Ricardo","M",27,"BRA",55,0,""
   ],["Tico","A",20,"BRA",61,0,""
   ],["Mayk","Z",27,"BRA",77,1,""
   ],["Marcelinho","Z",0,"BRA",79,1,""
   ],["Marcelo Rangel","G",38,"BRA",88,0,""
   ],["Ygor Vinhas","G",32,"BRA",94,0,""
   ],["Ivan","G",29,"BRA",97,0,""
   ],["João Lucas","L",28,"BRA",0,0,""
   ]
  ]
 }
];
